import { render, staticRenderFns } from "./ComplaintExportDialog.vue?vue&type=template&id=0f0b62ca"
import script from "./ComplaintExportDialog.vue?vue&type=script&lang=js"
export * from "./ComplaintExportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports